import { render, staticRenderFns } from "./Candidate.vue?vue&type=template&id=44bfb36c&scoped=true&"
import script from "./Candidate.vue?vue&type=script&lang=js&"
export * from "./Candidate.vue?vue&type=script&lang=js&"
import style0 from "./Candidate.vue?vue&type=style&index=0&id=44bfb36c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bfb36c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VIcon,VRow,VSheet})
